<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-form>
          <b-form-group label-cols-md="3">
            <template v-slot:label> No. Surat Perjanjian<span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="text" disabled v-model="dataAsal.nomorSuratPerjanjian" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> No. Surat Perintah<span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="text" disabled v-model="dataAsal.nomorSuratPerintah" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Nama Karyawan <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaKaryawan" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Divisi Karyawan <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaDivisi" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Posisi Karyawan <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaPosisi" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Mitra <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaMitra" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Koordinator <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaKoordinator" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Cabang <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaCabang" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Capem <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaCapem" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label="Nominal Gaji Pokok" label-cols-md="3">
            <b-form-input type="number" disabled v-model="dataAsal.nominalGajiKaryawan"></b-form-input>
          </b-form-group>
          <!-- <b-form-group label-cols-md="3">
            <template v-slot:label>
              Jabatan Manajemen <span class="text-danger">*</span>
            </template>
            <b-form-input
              size="lg"
              disabled
              type="text"
              v-model="dataAsal.posisiManajemen"
              style="width: 100%"
            ></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label>
              Nama Manajemen <span class="text-danger">*</span>
            </template>
            <b-form-input
              size="lg"
              disabled
              type="text"
              v-model="dataAsal.namaPejabatManajemen"
              style="width: 100%"
            ></b-form-input>
          </b-form-group> -->
          <b-form-group label-cols-md="3">
            <template v-slot:label> Tanggal Mulai Kontrak <span class="text-danger">*</span> </template>
            <DatePicker v-model="dataAsal.tanggalMulaiKontrak" style="width: 100%" disabled :placeholder="$moment(dataAsal.tanggalMulaiKontrak).format('ll')"></DatePicker>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Durasi Kontrak (bulan) <span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="number" v-model="dataAsal.masaKontrak" style="width: 100%" disabled></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Tanggal Selesai Kontrak <span class="text-danger">*</span> </template>
            <DatePicker disabled v-model="data.tanggalSelesaiKontrak" style="width: 100%" :placeholder="$moment(dataAsal.tanggalSelesaiKontrak).format('ll')"></DatePicker>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Detail Kontrak <span class="text-danger">*</span> </template>
            <b-form-textarea disabled v-model="dataAsal.detailKontrak" style="width: 100%"></b-form-textarea>
          </b-form-group>
        </b-form>
      </b-col>
      <!------------------------------------------------------------------------------------------------------>
      <!------------------------------------------------------------------------------------------------------>
      <b-col
        ><b-form>
          <b-form-group label-cols-md="3">
            <template v-slot:label> No. Surat Perjanjian<span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="text" v-model="$v.data.nomorSuratPerpanjangan.$model" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> No. Surat Perintah<span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="text" v-model="data.nomorSuratPerintah" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Nama Karyawan <span class="text-danger">*</span> </template>
            <multiselect
              v-model="$v.data.dataKaryawanId.$model"
              :options="karyawan"
              :multiple="false"
              :disabled="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              track-by="dataKaryawanId"
              label="namaKaryawan"
              placeholder="-- Pilih Karyawan --"
            ></multiselect>
          </b-form-group>
          <!-- <b-form-group label-cols-md="3">
            <template v-slot:label>
              Nama Karyawan <span class="text-danger">*</span>
            </template>
            <b-form-input
              size="lg"
              disabled
              type="text"
              v-model="data.namaKaryawan"
              style="width: 100%"
            ></b-form-input>
          </b-form-group> -->
          <!-- <b-form-group label-cols-md="3">
            <template v-slot:label>
              Divisi <span class="text-danger">*</span>
            </template>
            <multiselect
              v-model="$v.data.masterDivisiId.$model"
              :options="divisi"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              track-by="id"
              @input="
                getPosisi(data.masterDivisiId),
                  (data.namaDivisi = data.masterDivisiId.namaDivisi),
                  (data.masterPosisiId = '')
              "
              label="namaDivisi"
              placeholder="-- Pilih Karyawan --"
            ></multiselect>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label>
              Posisi <span class="text-danger">*</span>
            </template>
            <multiselect
              v-model="$v.data.masterPosisiId.$model"
              :options="posisi"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              track-by="id"
              @input="
                (data.namaPosisi = data.masterPosisiId.namaPosisi),
                  (data.jabatanBaru = data.masterPosisiId.namaPosisi)
              "
              label="namaPosisi"
              placeholder="-- Pilih Posisi --"
            ></multiselect>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label>
              Nama Mitra <span class="text-danger">*</span>
            </template>
            <multiselect
              v-model="$v.data.mitraId.$model"
              :state="checkIfValid('mitraId')"
              :options="dataMitra"
              @input="getKoordinator(data.mitraId), setPenempatan()"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaMitra"
              placeholder="-- Pilih --"
            ></multiselect>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label>
              Nama Koordinator <span class="text-danger">*</span>
            </template>
            <multiselect
              v-model="$v.data.koordinatorId.$model"
              :state="checkIfValid('koordinatorId')"
              :options="koordinator"
              @input="getCabang(data.koordinatorId), setPenempatan()"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaKoordinator"
              placeholder="-- Pilih --"
            ></multiselect>
          </b-form-group>
          <b-form-group label="Nama Cabang" label-cols-md="3">
            <multiselect
              v-model="data.cabangId"
              :options="cabang"
              @input="getCapem(data.cabangId), setPenempatan()"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaCabang"
              placeholder="-- Pilih --"
            ></multiselect>
          </b-form-group>
          <b-form-group label="Nama Capem" label-cols-md="3">
            <multiselect
              v-model="data.capemId"
              :options="capem"
              @input="setPenempatan()"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaCapem"
              placeholder="-- Pilih --"
            ></multiselect>
          </b-form-group> -->
          <b-form-group label-cols-md="3">
            <template v-slot:label> Divisi Karyawan <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="data.namaDivisi" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Posisi Karyawan <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="data.namaPosisi" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Mitra <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="data.namaMitra" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Koordinator <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="data.namaKoordinator" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Cabang <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="data.namaCabang" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Capem <span class="text-danger">*</span> </template>
            <b-form-input size="lg" disabled type="text" v-model="dataAsal.namaCapem" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label="Gaji Pokok" label-cols-md="3">
            <b-form-select :options="gapok" v-model="data.masterGajiId" @input="setNominal(data.masterGajiId)"></b-form-select>
          </b-form-group>
          <b-form-group label="Nominal Gaji Pokok" label-cols-md="3">
            <b-form-input type="number" :disabled="data.masterGajiId != 'fc39dbe3-4bfa-4400-8618-0eddf4a0fc65'" v-model="data.nominalGajiPerjanjian"></b-form-input>
          </b-form-group>
          <!-- <b-form-group label-cols-md="3">
            <template v-slot:label> Jabatan Manajemen <span class="text-danger">*</span> </template>
            <Multiselect
              v-model="data.posisiManajemenId"
              :options="manajemen"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              track-by="id"
              @input="(data.namaPejabatManajemen = data.posisiManajemenId.namaManajemen), (data.posisiManajemen = data.posisiManajemenId.jabatanManajemen)"
              label="jabatanManajemen"
              placeholder="-- Pilih Posisi --"
            ></Multiselect>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Nama Manajemen <span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="text" v-model="data.namaPejabatManajemen" style="width: 100%"></b-form-input>
          </b-form-group> -->
          <b-form-group label-cols-md="3">
            <template v-slot:label> Tanggal Mulai Kontrak <span class="text-danger">*</span> </template>
            <DatePicker v-model="$v.data.tanggalMulaiKontrak.$model" style="width: 100%" :placeholder="$moment(data.tanggalMulaiKontrak).format('ll')" @input="setExpire()"></DatePicker>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Durasi Kontrak (bulan) <span class="text-danger">*</span> </template>
            <b-form-input size="lg" type="number" v-model="$v.data.masaKontrak.$model" style="width: 100%" @input="setExpire()"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Tanggal Selesai Kontrak <span class="text-danger">*</span> </template>
            <DatePicker v-model="data.tanggalSelesaiKontrak" style="width: 100%" :placeholder="place"></DatePicker>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Penempatan <span class="text-danger">*</span> </template>
            <b-form-input v-model="data.penempatan" style="width: 100%"></b-form-input>
          </b-form-group>
          <b-form-group label-cols-md="3">
            <template v-slot:label> Detail Kontrak <span class="text-danger">*</span> </template>
            <b-form-textarea v-model="data.detailKontrak" style="width: 100%"></b-form-textarea>
          </b-form-group> </b-form
      ></b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-center">
        <b-button :disabled="!isValid || busy" variant="success" class="w-100" @click="simpan()">{{ button }}</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["karyawan", "dataAsal", "mutate", "dataMitra", "gapok"],
  name: "modalInput",
  data() {
    return {
      data: {
        tanggalDibuatSurat: null,
        nomorSurat: null,
        nomorSuratAwal: null,
        nomorSuratBaru: null,
        dataKaryawanId: null,
        tanggalMulaiKontrak: null,
        tanggalSelesaiKontrak: null,
        masaKontrak: null,
        statusPerjanjian: 0,
        statusKerjaKaryawan: 1,
        detailKontrak: null,
        masterDivisiId: null,
        namaDivisi: null,
        masterPosisiId: null,
        namaPosisi: null,
        posisiManajemen: null,
        namaPejabatManajemen: null,
        jabatanAwal: null,
        jabatanBaru: null,
        statusPerjanjianAktif: 5,
        jenisMutasi: null,
        posisiManajemenId: null,
        penempatan: null,
        mitraId: null,
        koordinatorId: null,
        cabangId: null,
        capemId: null,
      },
      divisi: [],
      manajemen: [],
      posisi: [],
      koordinator: [],
      cabang: [],
      capem: [],
      place: "",
      busy: false,
      button: "Konfirmasi Perpanjang Kontrak",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dataKaryawanId: { required },
      tanggalMulaiKontrak: { required },
      masaKontrak: { required },
      nomorSuratPerpanjangan: { required },
      masterDivisiId: { required },
      masterPosisiId: { required },
      mitraId: { required },
      // posisiManajemenId: { required },
    },
  },
  mounted() {
    const vm = this;
    vm.getPosisi();
    vm.getDivisi();
    vm.data.dataKaryawanId = vm.dataAsal.dataKaryawanId;
    vm.data.tanggalMulaiKontrak = vm.dataAsal.tanggalMulaiKontrak;
    vm.data.masaKontrak = vm.dataAsal.masaKontrak;
    vm.data.nomorSuratPerpanjangan = vm.dataAsal.nomorSuratPerpanjangan;
    vm.data.masterDivisiId = vm.dataAsal.masterDivisiId;
    vm.data.masterPosisiId = vm.dataAsal.masterPosisiId;
    vm.data.mitraId = vm.dataAsal.mitra_id;
    vm.data.posisiManajemenId = vm.dataAsal.posisiManajemenId;
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      console.log(field);
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    itikiwir2(x) {
      let vm = this;
      vm.data.statusKerjaKaryawan = x.statusKerjaKaryawan;
    },
    setNominal(x) {
      this.gapok.forEach((item) => {
        if (item.value == x) {
          this.data.nominalGajiPerjanjian = item.nominalGaji;
          this.data.namaGaji = item.namaGaji;
        }
      });
    },
    setPenempatan() {
      let vm = this;
      if (vm.data.capemId) {
        vm.data.penempatan = vm.data.capemId.namaCapem;
      } else {
        if (vm.data.cabangId) {
          vm.data.penempatan = vm.data.cabangId.namaCabang;
        } else {
          if (vm.data.koordinatorId) {
            vm.data.penempatan = vm.data.koordinatorId.namaKoordinator;
          } else {
            vm.data.penempatan = vm.data.mitraId.namaMitra;
          }
        }
      }
    },
    // async getMitra() {
    //   let vm = this
    //   let listMitra = await vm.$axios.get("mitra/list");
    //   vm.dataMitra = listMitra.data.data;
    // },
    // async getKoordinator(x) {
    //   let vm = this
    //   if (x) {
    //     let koordinator = await vm.$axios.get(
    //       "koordinator/listKoordinatorByMitraId/" + x.id
    //     );
    //     vm.koordinator = koordinator.data.data;
    //     vm.data.koordinatorId = "";
    //     vm.data.cabangId = "";
    //     vm.data.capemId = "";
    //   } else if (!x) {
    //     vm.data.koordinatorId = "";
    //     vm.data.cabangId = "";
    //     vm.data.capemId = "";
    //   }
    // },
    async getCabang(x) {
      let vm = this;
      if (x) {
        let cabang = await vm.$axios.get("cabang/list");
        vm.cabang = cabang.data.data;
        vm.data.cabangId = "";
        vm.data.capemId = "";
      } else if (!x) {
        vm.data.cabangId = "";
        vm.data.capemId = "";
      }
    },
    // async getCapem(x) {
    //   let vm = this
    //   if (x) {
    //     let capem = await vm.$axios.get("capem/listCapemByCabangId/" + x.id);
    //     vm.capem = capem.data.data;
    //     vm.data.capemId = "";
    //   } else if (!x) {
    //     vm.data.capemId = "";
    //   }
    // },
    async getDivisi() {
      let vm = this;
      let divisi = await vm.$axios.post("masterDivisi/list");
      vm.divisi = divisi.data.data;

      let manajemen = await vm.$axios.post("masterManajemen/list");
      vm.manajemen = manajemen.data.data;
      // console.log('manajemen', manajemen);
    },
    async getPosisi() {
      let vm = this;
      let posisi = await vm.$axios.post("masterPosisi/list");
      // console.log(posisi.data.data);
      vm.posisi = posisi.data.data;
    },
    // setKaryawan() {
    //   console.log('setKaryawan')
    //   for (let i = 0; i < this.karyawan.length; i++) {
    //     if (this.karyawan[i].dataKaryawanId == this.dataAsal.dataKaryawanId) {
    //       this.data.dataKaryawanId = this.karyawan[i];
    //     }
    //   }
    // },
    setKaryawan() {
      let vm = this;
      this.getCabang();
      // console.log(this.dataAsal, "asal");
      vm.data = {
        tanggalDibuatSurat: vm.$moment(),
        nomorSurat: "",
        nomorSuratPerjanjian: vm.dataAsal.nomorSuratPerjanjian,
        dataKaryawanId: { dataKaryawanId: vm.dataAsal.dataKaryawanId, namaKaryawan: vm.dataAsal.namaKaryawan },
        namaKaryawan: vm.dataAsal.namaKaryawan,
        tanggalMulaiKontrak: vm.$moment(vm.dataAsal.tanggalSelesaiKontrak).add(1, "days"),
        tanggalSelesaiKontrak: "",
        masaKontrak: "",
        statusPerjanjian: 0,
        statusKerjaKaryawan: 1,
        detailKontrak: "",
        nomorSuratPerpanjangan: "",
        masterDivisiId: vm.dataAsal.masterDivisiId,
        namaDivisi: vm.dataAsal.namaDivisi,
        masterPosisiId: vm.dataAsal.masterPosisiId,
        namaPosisi: vm.dataAsal.namaPosisi,
        jabatanAwal: vm.dataAsal.namaPosisi,
        jabatanBaru: "",
        statusPerjanjianAktif: 4,
        jenisMutasi: "",
        posisiManajemenId: "",
        mitraId: vm.dataAsal.mitra_id,
        namaMitra: vm.dataAsal.namaMitra,
        cabangId: vm.dataAsal.cabangId,
        namaCabang: vm.dataAsal.namaCabang,
        koordinatorId: vm.dataAsal.koordinatorId,
        namaKoordinator: vm.dataAsal.namaKoordinator,
        capemId: vm.dataAsal.capemId,
        namaCapem: vm.dataAsal.namaCapem,
        penempatan: vm.dataAsal.penempatan,
        masterGajiId: "",
        nominalGajiPerjanjian: "",
      };
    },
    setExpire() {
      let vm = this;
      vm.data.tanggalSelesaiKontrak = vm.$moment(vm.data.tanggalMulaiKontrak).add(vm.data.masaKontrak, "month").subtract(1, "days");
      vm.place = vm.$moment(vm.data.tanggalMulaiKontrak).add(vm.data.masaKontrak, "month").subtract(1, "days").format("YYYY-MM-DD");
    },
    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.tanggalPerpanjangKontrak = vm.$moment();
      vm.data.tanggalMutasi = vm.data.tanggalMulaiKontrak;
      vm.data.jenisMutasi = "Perpanjangan";
      // console.log(vm.data);
      vm.$axios
        .post("suratPerjanjianKerja/perpanjangPerjanjian", {
          ...vm.data,
          dataKaryawanId: vm.data.dataKaryawanId.dataKaryawanId,
        })
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Konfirmasi Perpanjangan";
            vm.reset();
            vm.$v.$reset();
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MEMPERPANJANG DURASI KONTRAK KARYAWAN",
              showing: true,
            });
            this.$bvModal.hide("modal-input");
          } else {
            vm.button = "Konfirmasi Mutasi";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Konfirmasi Mutasi";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: err.message,
            showing: true,
          });
        });
    },
    reset() {
      this.data = {
        tanggalDibuatSurat: "",
        nomorSurat: "",
        nomorSuratAwal: "",
        nomorSuratBaru: "",
        dataKaryawanId: "",
        tanggalMulaiKontrak: "",
        tanggalSelesaiKontrak: "",
        masaKontrak: "",
        statusPerjanjian: 0,
        statusKerjaKaryawan: 1,
        detailKontrak: "",
        masterDivisiId: "",
        namaDivisi: "",
        masterPosisiId: "",
        namaPosisi: "",
        posisiManajemen: "",
        namaPejabatManajemen: "",
        jabatanAwal: "",
        jabatanBaru: "",
        statusPerjanjianAktif: 5,
        jenisMutasi: "",
        posisiManajemenId: "",
      };
    },
  },
  watch: {
    mutate: function (newVal, oldVal) {
      // console.log('mutate', newVal, oldVal)
      if (newVal != oldVal) {
        this.setKaryawan();
      }
    },
  },
};
</script>
